import { CONFIRM_CANDIDATE_ACCOUNT, CandidateAccountConfirmation } from '../../types/applicant/confirm-candidate'

export const confirmCandidateAccount = (payload: CandidateAccountConfirmation) => {
  return {
    type: CONFIRM_CANDIDATE_ACCOUNT,
    payload,
  }
}
